import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { DocsProvider } from './lib/gitbook';
import './index.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-loading-skeleton/dist/skeleton.css';

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <DocsProvider>
      <App />
    </DocsProvider>
  </StrictMode>
);
